// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import DataAuthorizeSvg from '@rsuite/icon-font/lib/application/DataAuthorize';
var DataAuthorize = createSvgIcon({
  as: DataAuthorizeSvg,
  ariaLabel: 'data authorize',
  category: 'application',
  displayName: 'DataAuthorize'
});
export default DataAuthorize;